import { ActivatedRoute } from '@angular/router';

import { Question } from 'src/app/_models/question';

import { QuizService } from './../../_services/quiz.service';

import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { INPUT, RADIOGROUP } from 'src/app/_models/data/constants';

@Component({
  selector: 'app-admin-show-question-detail',
  templateUrl: './admin-show-question-detail.component.html',
  styleUrls: ['./admin-show-question-detail.component.css']
})
export class AdminShowQuestionDetailComponent implements OnInit {
  @Input() question = new Question()
  answerGiven:any
  server_quiz_envelop_id=0
  doQuestionForm:FormGroup
  answerValue=""
  isRadioGroup = false
  isInput = false

  loading=false
  constructor( private quizService: QuizService, private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.loading=true
    this.isRadioGroup=this.question.questionPresentation==RADIOGROUP
    this.isInput=this.question.questionPresentation==INPUT

    this.activatedRoute.params.subscribe(
      params=>{
        this.server_quiz_envelop_id=params['server_quiz_envelop_id']
        this.quizService.getQuestionAdmin(params['server_question_id'],this.server_quiz_envelop_id).subscribe(
          myQuestion=>{
            this.question=myQuestion
            this.answerGiven= this.question.answerGiven
            this.initForm()
            this.loading=false
          }
        )
      }
    )


  }
  ngOnChanges() {
    this.initForm()
  }

  initForm(){
    if(this.isInput){
      this.doQuestionForm= new FormGroup(
        {'answerInput': new FormControl(this.question.answerGiven.display)}
        )
    }else if(this.isRadioGroup){
      this.doQuestionForm= new FormGroup(
        {'answerChoice': new FormControl(this.answerGiven.value)}
        )
    }
  }
  extractChoiceValue(choice){
    return choice.value
  }

}
